import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedList } from '../interface';
import { InvoiceModel, InvoiceResourceService, InvoiceStatus, InvoiceType } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxInvoiceService {
  constructor(
    private api: InvoiceResourceService,
  ) {
  }

  rejectBalance(invoiceId: number, reason: string): Observable<void> {
    return this.api.rejectInvoice(invoiceId, {reason} as any);
  }

  getInvoiceById(invoiceId: number): Observable<InvoiceModel> {
    return this.api.getInvoiceById(invoiceId) as unknown as Observable<InvoiceModel>;
  }

  discardBalance(request: DiscardBalanceRequest): Observable<void> {
    return this.api.discardProducts(request as any);
  }

  getInvoiceList(params?: {
    storeId?: number,
    date?: string,
    statuses?: InvoiceStatus[],
    productInfoIds?: number[],
    limit?: number,
    page?: number,
    supplierId?: number,
  }): Observable<PagedList<InvoiceModel>> {
    return this.api.getInvoices(params?.date, params?.limit, params?.page, params?.productInfoIds, params?.statuses, params?.storeId) as unknown as Observable<PagedList<InvoiceModel>>;
  }

  createInvoice(body: CreateInvoiceRequest): Observable<void> {
    return this.api.insertInvoice(body as any);
  }

  cancelInvoice(invoiceId: number, reason: string): Observable<void> {
    return this.api.cancelInvoice(invoiceId, {reason} as any);
  }

  acceptInvoice(invoiceId: number): Observable<void> {
    return this.api.receiveInvoice(invoiceId);
  }

  sendPartially(id: number, products: InvoiceProductAmountModel[]): Observable<void> {
    return this.api.sendInvoicePartially(id, products as any);
  }

  sendInvoice(id: number): Observable<void> {
    return this.api.sendInvoice(id);
  }

  restoreInvoice(id: number): Observable<void> {
    return this.api.restoreInvoice(id);
  }
}

export interface DiscardBalanceRequest {
  storeId: number;
  reason: string;
  receiveUserId: number;
  fileIds: number[];
  products: { productInfoId: number, amount: number }[];
  invoiceType: InvoiceType;
}

export interface CreateInvoiceRequest {
  fromStoreId?: number;
  toStoreId: number;
  description: string;
  restoration?: boolean;
  products: InvoiceProductAmountModel[];
}

export interface InvoiceProductAmountModel {
  productInfoId: number;
  amount: number;
}
